import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './threadActionTypes';
import * as actions from './threadActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getThreadSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };

    const { data } = yield call(endpoints.getThreads, payload);
    yield put(actions.getThreadDataAction(data));
  } catch (e) {
    yield put(actions.getThreadErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createThreadSaga(action) {
  try {
    console.log('createThreadSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create thread API payload:', payload);
    
    const { data } = yield call(endpoints.createThread, payload);
    console.log('Create thread API response:', data);
    
    yield put(actions.createThreadDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/thread');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createThreadSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createThreadErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateThreadSaga(action) {
  try {
    console.log('updateThreadSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update thread API payload:', payload);
    
    const { data } = yield call(endpoints.updateThread, payload);
    console.log('Update thread API response:', data);
    
    yield put(actions.updateThreadDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      console.log("GİRDİDDDİİİİ")
      
        setTimeout(() => {
          window.location.href ='/thread'
        }, 1000);
    }
    
  } catch (e) {
    console.error('updateThreadSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateThreadErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteThreadSaga(action) {
  try {
    console.log('deleteThreadSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete thread API payload:', payload);
    
    const { data } = yield call(endpoints.deleteThread, payload);
    console.log('Delete thread API response:', data);
    
    yield put(actions.deleteThreadDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getThreadRequestAction());
    }
    
  } catch (e) {
    console.error('deleteThreadSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteThreadErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* threadSaga() {
  yield all([
    takeEvery(types.GET_THREAD_REQUEST, getThreadSaga),
    takeEvery(types.CREATE_THREAD_REQUEST, createThreadSaga),
    takeEvery(types.UPDATE_THREAD_REQUEST, updateThreadSaga),
    takeEvery(types.DELETE_THREAD_REQUEST, deleteThreadSaga),
  ]);
}
